import { useMemo } from 'react';
import type { Store } from '../services/types';
import { useCurrentUrl } from './useCurrentUrl';

type UseEnableOnPatternsProps = {
  store?: Store;
};

export const useEnableOnPatterns = ({ store }: UseEnableOnPatternsProps) => {
  const currentUrl = useCurrentUrl();

  const isEnabledOnPatterns = useMemo(() => {
    const enablePatterns =
      store?.config?.config?.answerConfig?.enableOnPatterns;

    if (!enablePatterns?.length) {
      return true; // If no patterns are defined, enable by default
    }

    return enablePatterns.some((pattern) => {
      try {
        return new RegExp(pattern).test(currentUrl);
      } catch (error) {
        console.warn(`Invalid regex pattern: ${pattern}`, error);
        return false;
      }
    });
  }, [currentUrl, store?.config?.config?.answerConfig?.enableOnPatterns]);

  return {
    isEnabledOnPatterns,
    currentUrl,
  };
};
